import { css } from '@emotion/react';
import {
  PauseCircle,
  PlayCircle,
  ArrowLeft,
  ArrowRight,
} from '@mui/icons-material';
import { Stack, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { useScreenViewerContext } from './ScreenViewerContext';

const style = {
  root: css`
    position: fixed;
    bottom: 2rem;
    z-index: 100;
    left: 0;
    right: 0;
    opacity: 0;
    transition: opacity 0.5;

    &:hover {
      opacity: 1;
    }

    .controller {
      margin: 0 auto;
      text-align: center;
      background: white;
      padding: 1rem;
      border-radius: 9999px;
    }
  `,
};

export const ScreenViewerController = () => {
  const { page, screens, autoPlay, play, paginate, pause } =
    useScreenViewerContext();

  return (
    <Box css={style.root}>
      <Stack spacing={1}>
        <Stack className="controller" direction="row" spacing={2}>
          <IconButton
            onClick={() => {
              pause();
              paginate(-1);
            }}
          >
            <ArrowLeft />
          </IconButton>
          <IconButton
            onClick={() => {
              if (autoPlay) {
                pause();
              } else {
                play();
              }
            }}
          >
            {autoPlay ? <PauseCircle /> : <PlayCircle />}
          </IconButton>
          <IconButton
            onClick={() => {
              pause();
              paginate(1);
            }}
          >
            <ArrowRight />
          </IconButton>
        </Stack>
        <Typography align="center">{`Ecran ${page + 1}/${
          screens?.length
        }`}</Typography>
      </Stack>
    </Box>
  );
};
